import React, { useState } from 'react';
import { PopupModal } from '../../../Modals/Index';
import { SelectInput } from '../../../Components/index';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import './Index.css';
import { PrintingOptions } from '../..';

const Index = ({ state, setStateFalse }) => {
    const [popup, setPopup] = useState(false);
    const [gender, setGender] = useState('M');
    const [category, setCategory] = useState('H');
    return (
        <>
            <PrintingOptions
                state={popup}
                setStateFalse={() => {
                    setPopup((prev) => !prev);
                }}
            />
            <PopupModal setStateFalse={setStateFalse} state={state}>
                <div style={{ width: 'max-content' }} className="popupConatiner">
                    <div className="home_head">
                        <h2 className="home_heading">Choose Product Design</h2>
                    </div>
                    <div className="popup_body">
                        <div className="select_container">
                            <SelectInput
                                value={gender}
                                changeHandler={(e) => {
                                    setGender(e.target.value);
                                }}
                                options={[
                                    { name: "Men's Clothing", value: 'M' },
                                    { name: "Women's Clothing", value: 'F' },
                                    { name: "Child's Clothing", value: 'C' },
                                ]}
                            />
                            <SelectInput
                                value={category}
                                changeHandler={(e) => {
                                    setCategory(e.target.value);
                                }}
                                options={[
                                    { name: 'Half Sleeve Round Neck T-Shirt', value: 'H' },
                                    { name: 'Full Sleeve Round Neck T-Shirt', value: 'F' },
                                ]}
                            />
                        </div>
                        <div className="footer_button">
                            <button style={{ marginRight: '2rem' }} onClick={setStateFalse} className="btn-gray">
                                <KeyboardBackspaceIcon className="btn-icon " />
                                <p>Back</p>
                            </button>
                            <button
                                onClick={() => {
                                    setStateFalse();
                                    setPopup((prev) => !prev);
                                }}
                                className="btn-orange "
                            >
                                <p>Proceed</p>
                            </button>
                        </div>
                    </div>
                </div>
            </PopupModal>
        </>
    );
};

export default Index;
